export function toMoney(n: number): string {
    const v = Number.isFinite(n) ? n : 0;
    return v.toLocaleString('ru-RU');
}
